import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/seeker/$")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: "/candidate/" + params._splat })
  },
  component: () => null,
})
